<template>
  <!-- This is a Contributors post wrapper (to handle different/reused CW/CD layouts cleanly) -->
  <div class="home-wrapper h-screen ml-56">
    <!-- Page content -->
    <div class="w-full h-full overflow-y-scroll bg-truegray-100">
      <CWPost v-if="postId" :post_id="postId" :edit="edit" :page="page" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, watch } from 'vue'
import { useStore } from '../../../js/store/index.js'
import { useRouter } from 'vue-router/composables'
import CWPost from '../../../careerwise/tenant/public/pages/Post.vue'

export default defineComponent({
  name: 'Post',

  components: {
    CWPost,
  },

  props: {
    postId: {
      type: Number,
      default: () => null,
    },

    edit: {
      type: Boolean,
      default: false,
    },

    page: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const store = useStore()
    const router = useRouter()

    const organisationId = computed(
      () => store.getters['contributors/getOrganisationId'],
    )
    watch(organisationId, () => {
      router.push({ name: 'ContributorsPosts' })
    })

    return {}
  },
})
</script>
